import { StyleSheet } from 'aphrodite'

import list from './list'
import transaction from './transaction'

export default {
  list: StyleSheet.create(list),
  transaction: StyleSheet.create(transaction)
}



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/BillingTable/style/ColorBlind/index.js